import { Alert, Checkbox, Container } from "@mui/material";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";

import React, { useState, useEffect } from "react";
import { observer } from "mobx-react";
import { Tooltip } from "@mui/material";
import { Button } from "@mui/material";
import BusyIndicator from "SandboxViewerComponent/src/widgets/mu-authorization/components/BusyIndicator";
import PrintArea from "./src/utils/PrintArea";
import PrintLogik from "./src/utils/PrintLogik";
import TemplateFetcher from "./src/utils/TemplateFetcher";
import RootStore from "SandboxViewerComponent/src/stores/RootStore";
import { Divider } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { helpUrl } from "configs/config";

const config = {
  name: "PrintReactWidget",
  layerCollection: [],
  label: "Drucken",
  scales: [
    {
      display: "1:10.000",
      value: "10000.0",
    },
    {
      display: "1:12.500",
      value: "12500.0",
    },
    {
      display: "1:25.000",
      value: "25000.0",
    },
    {
      display: "1:50.000",
      value: "50000.0",
    },
    {
      display: "1:62.500",
      value: "62500.0",
    },
    {
      display: "1:100.000",
      value: "100000.0",
    },
    {
      display: "1:125.000",
      value: "125000.0",
    },
    {
      display: "1:250.000",
      value: "250000.0",
    },
    {
      display: "1:500.000",
      value: "500000.0",
    },
  ],
  getTemplatesURL:
    "https://www.umweltkarten-niedersachsen.de/arcgis/rest/services/print/getTemplates/GPServer/get%20Templates/execute?template_path=E%3A%5CRessourcen%5CMxd%5CTemplates%5CAGSPrintTemplates&env%3AoutSR=&env%3AprocessSR=&returnZ=false&returnM=false&returnTrueCurves=false&returnFeatureCollection=false&context=&f=json",
  printURL:
    "https://www.umweltkarten-niedersachsen.de/rest/services/print/create.json?url=https%3A%2F%2Fwww.umweltkarten-niedersachsen.de%2Frest%2Fservices%2Fprint%2Fcreate.json",
  printSR: 25832,
  dpi: 150,
  widgetHelpUrl: "/zusatzfunktionen/drucken",
  nonPrintableLayers: ["WMS NI Verwaltungsgrenzen"],
};

const scales = [
  {
    display: " - ",
    value: "0.0",
  },
].concat(config.scales);

const PrintWidget = observer(({ view }) => {
  const [useLegend, setUseLegend] = useState(true);
  const [popupsDisabled, setPopupsDisabled] = useState(true);
  const [mapScale, setMapScale] = useState({ value: "0.0" });
  const [mapTemplate, setMapTemplate] = useState({
    value: "",
  });
  const [templates, setTemplates] = useState([]);
  // const [scales, setScales] = useState(initalScales);
  const [loading, setLoading] = useState(false);
  const [printError, setPrintError] = useState(null);
  const [currentExtent, setCurrentExtent] = useState(null);
  const setMapTemplate2 = (event) => {
    const newTemplate = templates.filter((i) => {
      return i.value === event.target.value;
    })[0];
    setMapTemplate(newTemplate);
    refreshPrintArea(mapScale, newTemplate);
  };
  const setMapScale2 = (event) => {
    const newValue = scales.filter((i) => {
      return i.value === event.target.value;
    })[0];
    setMapScale(newValue);
    refreshPrintArea(newValue, mapTemplate);
  };
  const setUseLegend2 = (event) => {
    setUseLegend(!useLegend);
  };
  const setTemplates2 = (newTemplates) => {
    setTemplates(newTemplates);
    setMapTemplate(newTemplates[newTemplates.length - 1]);
  };
  const loadingTemplateChanged = (newLoading) => {
    setLoading(newLoading);
  };
  const refreshPrintArea = (newMapScale, newMapTemplate) => {
    printArea.current.drawPrintArea(newMapScale, newMapTemplate);
  };
  const onPrintReady = (resultURL) => {
    window.open(resultURL, "_blank");
    setLoading(false);
  };
  const printArea = React.createRef();
  const printLogic = React.createRef();

  const { mapStore } = RootStore;
  const mobile = RootStore.uiStore.BBStore.mobile;
  const spacer = mobile ? 5 : 10;
  const selectSize = mobile ? "small" : "medium";
  const containerPadding = mobile ? 8 : 15;

  const onPrintError = (error) => {
    console.error(error);
    setLoading(false);
    const isFetchError =
      error instanceof TypeError && error.message === "Failed to fetch";
    setPrintError(
      isFetchError
        ? `Druckdienst nicht erreichbar. Die Anfrage an den Server wurde abgebrochen (möglicherweise blockiert durch CORS, Firewall oder Netzwerkfehler). Details in der Browser-Konsole.`
        : `Beim Drucken ist ein Fehler aufgetreten: ${error?.message || String(error)
        }`
    );
  };
  useEffect(() => {
    const popup = window.open("", "_blank", "width=10,height=10");
    if (popup) {
      setPopupsDisabled(false);
      popup.close();
    }
  }, []);
  useEffect(() => {
    if (RootStore.mapStore.isPrintWidgetExpanded) {
      printArea.current.componentDidMount();
    } else {
      printArea.current.componentWillUnmount();
    }
  }, [RootStore.mapStore.isPrintWidgetExpanded]);

  if (loading) {
    return (
      <Container
        style={{
          background: "white",
          paddingTop: containerPadding,
          paddingBottom: containerPadding,
        }}
      >
        <BusyIndicator label="Druck wird ausgeführt" />
      </Container>
    );
  }
  return (
    <Container
      style={{
        background: "white",
        paddingTop: containerPadding,
        paddingBottom: containerPadding,
        maxHeight: mobile ? 300 : 525,
        overflowY: "auto",
      }}
    >
      {helpUrl && (
        <div
          style={{
            position: "absolute",
            right: 5,
            top: 5,
          }}
        >
          <a
            href={helpUrl + config.widgetHelpUrl}
            target="Hilfe"
            title="Hilfe öffnen"
          >
            <FontAwesomeIcon icon={faQuestionCircle} color="grey" />
          </a>
        </div>
      )}
      <div>
        {popupsDisabled
          ? "Achtung, Popups für diese Seite werden blockiert, bitte aktivieren Sie Popups um Drucken zu können."
          : ""}
      </div>
      <PrintArea
        map={mapStore.map}
        mapView={mapStore.mapView}
        ref={printArea}
        mapTemplate={mapTemplate}
        mapScale={mapScale}
        onChangeExtent={setCurrentExtent}
      />

      <PrintLogik
        map={mapStore.map}
        mapView={mapStore.mapView}
        ref={printLogic}
        onPrintReady={onPrintReady}
        onPrintError={onPrintError}
        mapTemplate={mapTemplate}
        mapScale={mapScale}
        mapTitle={"mapTitle"}
        config={config}
        printArea={currentExtent}
        useLegend={useLegend}
      />
      <TemplateFetcher
        url={config.getTemplatesURL}
        onChangeLoading={loadingTemplateChanged}
        onChangeTemplates={setTemplates2}
      />
      <Tooltip title={"Auswahl der Blattgröße und der Ausrichtung"}>
        <Select
          variant="outlined"
          size={selectSize}
          onChange={setMapTemplate2}
          fullWidth
          value={mapTemplate.value}
        >
          {templates.map((newMapTemplate) => (
            <MenuItem
              key={`${newMapTemplate.value}`}
              value={newMapTemplate.value}
            >
              {newMapTemplate.display}
            </MenuItem>
          ))}
        </Select>
      </Tooltip>
      <div style={{ height: spacer }}></div>
      <Tooltip title={"Auswahl des Druckmaßstab (optional)"}>
        <Select
          variant="outlined"
          size={selectSize}
          onChange={setMapScale2}
          fullWidth
          value={mapScale.value}
        >
          {scales.map((tmpMapScale) => (
            <MenuItem key={`${tmpMapScale.value}`} value={tmpMapScale.value}>
              {tmpMapScale.display}
            </MenuItem>
          ))}
        </Select>
      </Tooltip>
      <div style={{ height: spacer }}></div>
      <Tooltip
        title={
          "Durch einen Klick aktivieren oder deaktivieren Sie die Ausgabe der Legende in der Karte"
        }
      >
        <FormControlLabel
          control={
            <Checkbox
              size={selectSize}
              onChange={() => {
                setUseLegend2(!useLegend);
              }}
              checked={useLegend}
            />
          }
          label={"Legende mitdrucken"}
        />
      </Tooltip>
      <div style={{ height: spacer }}></div>
      <Divider />
      <div style={{ height: spacer }}></div>
      {printError && (
        <Alert severity="error" style={{ marginBottom: spacer }}>
          {printError}
        </Alert>
      )}
      <Tooltip title={"Erstellen des Drucks"}>
        <span>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setPrintError(null);
              setLoading(true);
              printLogic.current.print();
            }}
          >
            {"Drucken"}
          </Button>
        </span>
      </Tooltip>
    </Container>
  );
});

export default PrintWidget;
